import { jsx } from "react/jsx-runtime";
import React from "react";
var link_out_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.9989 4.9961v-1h-1l-4.9969.0001v2h2.5827l-5.296 5.2962 1.4143 1.4141 5.2959-5.2961v2.5887h2V4.996zM4.0019 19.9993v-16h8.0001v2H6.0019v12H18.002v-6h2v8H4.0019z" })];
};
export {
  link_out_default as default
};
